export default "__VITE_ASSET__DETZUN33__"